import type { ChipTone } from '@/components/common/StatusChip';
import type { Migration, MigrationStatus } from '@/features/migrations/types';

export const ACTIVE_STATUSES: MigrationStatus[] = ['queued', 'connecting', 'running'];

export const isActive = (m: Pick<Migration, 'status'>): boolean => ACTIVE_STATUSES.includes(m.status);

export function statusLabel(m: Pick<Migration, 'status' | 'cancelRequested'>): string {
  if (m.cancelRequested && ACTIVE_STATUSES.includes(m.status)) return 'Cancelling';
  switch (m.status) {
    case 'queued': return 'Queued';
    case 'connecting': return 'Connecting';
    case 'running': return 'Copying';
    case 'completed': return 'Completed';
    case 'completed_with_warnings': return 'Completed with warnings';
    case 'failed': return 'Failed';
    case 'cancelled': return 'Cancelled';
  }
}

export function statusTone(s: MigrationStatus): ChipTone {
  if (s === 'completed') return 'success';
  if (s === 'completed_with_warnings') return 'warning';
  if (s === 'failed') return 'danger';
  if (s === 'cancelled') return 'neutral';
  return 'info';
}

/** Per-folder verification: does the destination hold at least what we expected to copy? */
export function folderVerified(f: { status: string; messagesTotal: number; messagesFailed: number; destinationMessages: number | null }): 'ok' | 'mismatch' | 'n/a' {
  if (f.status === 'skipped' || f.destinationMessages === null) return 'n/a';
  return f.destinationMessages >= f.messagesTotal - f.messagesFailed ? 'ok' : 'mismatch';
}
